import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Landing from "@/pages/Landing";
import EditorialBoard from "@/pages/EditorialBoard";
import EditorProfile from "@/pages/EditorProfile";
import Accessibility from "@/pages/Accessibility";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";
import ReadingProgress from "@/components/landing/ReadingProgress";
import CookieBanner from "@/components/landing/CookieBanner";
import CommandPalette from "@/components/landing/CommandPalette";
import ScrollToTop from "@/components/landing/ScrollToTop";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <ReadingProgress />
          <CommandPalette />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/editorial-board/:journalId" element={<EditorialBoard />} />
            <Route path="/editor/:slug" element={<EditorProfile />} />
            <Route path="/accessibility" element={<Accessibility />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
